import * as React from 'react';
import './OAuthButton.css';

interface OAuthButtonProps {
  label: string;
  logo: string;
  onClick: () => void;
}

const OAuthButton: React.FC<OAuthButtonProps> = ({ label, logo, onClick }) => {
  return (
    <button className="oauth-button" onClick={onClick}>
      <img src={logo} alt={`${label} logo`} className="oauth-icon" />
      {label}
    </button>
  );
};

export default OAuthButton;
